import React from 'react';

import { Messages } from '../../codegen/Localize';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { getAppStore } from '../../app/AppStore';
import { BreadcrumbStateInfo } from '../../app/content/breadcrumbs/BreadcrumbStateInfo';
import { ServerUrls } from '../../app/ServerUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../../app/spaces/RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { ConnectedAllSchedulesSpace } from './ConnectedAllSchedulesSpace';

export interface AllSchedulesSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls | ServerUrls;
}

const AllSchedulesSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'schedules',
  subspaceName: undefined
};

export const AllSchedulesSpaceProvider: React.FunctionComponent<AllSchedulesSpaceProviderProps> = (props) => {

  React.useEffect(() => {
    getAppStore().dispatch(updateBreadcrumbs([getSchedulesPlaceBreadcrumb(props.urls)]));
  }, []);

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSchedulesSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={false}
        shouldUpdateSort={true}
      >
        <ConnectedAllSchedulesSpace
          angularContext={props.angularContext}
          siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getSchedulesPlaceBreadcrumb(urls: SpacesSiteUrls | ServerUrls): BreadcrumbStateInfo {
  const href = urls.schedulesUrl();
  return {
    id: href,
    text: Messages.allSchedules(),
    href: href,
    testId: 'schedules-link'
  };
}
